export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.licenseInfo = this.licenseDetails.licenseInfo;
        this.currentPlan = this.licenseDetails.companyLicensePlan;
        this.featureUsages = [];
        if(this.licenseDetails.featureUsages.length > 0) {
            this.featureUsages = JSON.parse(this.licenseDetails.featureUsages);
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/current-plan/current-plan.controller.js